import { render } from "./NewCategoriesCard.vue?vue&type=template&id=7fa59abf&scoped=true"
import script from "./NewCategoriesCard.vue?vue&type=script&lang=js"
export * from "./NewCategoriesCard.vue?vue&type=script&lang=js"

import "@/assets/css/news/index.css?vue&type=style&index=0&id=7fa59abf&lang=css&scoped=true"
import "./NewCategoriesCard.vue?vue&type=style&index=1&id=7fa59abf&scoped=true&lang=css"
import "@/assets/css/news/index.css?vue&type=style&index=2&id=7fa59abf&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa59abf"]])

export default __exports__